<template>
  <div>
    <el-form :model="form" :rules="rules" ref="formRef" style="margin-left: 35px">
      <el-form-item prop="phone">
        <el-input class="phone" v-model="form.phone" placeholder="请输入手机号" style="width:88%;height:60px;margin-top:40px;">
          <template #prepend>+86</template>
          <template #append>
            <span 
              @click="sendSmsCode" 
              :class="{ 'disabled': countdown > 0 || sending }"
              style="cursor:pointer;">
              {{ countdown > 0 ? `已发送(${countdown}s)` : (sending ? '发送中...' : '发送验证码') }}
            </span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input class="email_login" v-model="form.code" placeholder="请输入验证码"
          autocomplete="off"
          style="width:88%;height:60px;">
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="form.password" type="password" placeholder="请输入新密码" 
          autocomplete="new-password"
          :show-password="true" style="width:88%;">
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" placeholder="请确认新密码" 
          autocomplete="new-password"
          :show-password="true" style="width:88%;">
        </el-input>
      </el-form-item>
    </el-form>
    <div class="flex-row" style="width:100%;justify-content: space-around;">
      <button class="submitButton" @click="handleSubmit">提交</button>
      <router-link to="/store/entry/loginEmail">
        <button class="submitButton">返回</button>
      </router-link>
    </div>
  </div>
</template>
<script>
import { sendSmsCode } from '@/api/user'
import { resetPassword } from '@/api/user'

export default {
  data() {
    // 确认密码的自定义验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'login',
      countdown: 0,
      sending: false,
      form: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少为 6 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    startCountdown(key = 'countdown', seconds = 60) {
      this[key] = seconds
      const timer = setInterval(() => {
        if (this[key] > 0) {
          this[key] -= 1
        } else {
          clearInterval(timer)
        }
      }, 1000)
    },
    async sendSmsCode() {
      // 如果正在发送或者倒计时中，直接返回
      if (this.countdown > 0 || this.sending) return
      
      // 验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      
      try {
        this.sending = true
        const response = await sendSmsCode({ mobile: this.form.phone, scene: 'ZHDLMM' })
        if (response.data.code == 1) {
          this.$message.success('验证码已发送，请注意查收')
          this.startCountdown('countdown', 60)
        } else {
          this.$message.error(response.data.msg || '发送失败，请稍后重试')
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$message.error('发送失败，请稍后重试')
      } finally {
        this.sending = false
      }
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return

        try {
          const response = await resetPassword({
            mobile: this.form.phone,
            code: this.form.code,
            password: this.form.password,
            password_confirm: this.form.confirmPassword
          })

          if (response.data.code == 1) {
            this.$message.success('密码重置成功')
            setTimeout(() => {
              this.$router.push('/store/entry/loginEmail')
            }, 1000)
          }
        } catch (error) {
          console.error('重置密码失败:', error)
        }
      })
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 18px 0px 0px 18px;
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 60px;
  font-size: large;
  border-radius: 18px;
}

::v-deep .phone .el-input__inner {
  border-radius: 0px;
}

::v-deep .el-input-group__append {
  cursor: pointer;
  color: #7EB4EB;
  transition: color 0.3s;
}

::v-deep .el-input-group__append:hover {
  color: #B16EF9;
}

::v-deep .el-input-group__append .disabled {
  cursor: not-allowed;
  color: #bfbfbf;
}

::v-deep .el-input-group__append:hover .disabled {
  color: #bfbfbf;
}

.submitButton {
  width:180px;height:50px;
  border-radius: 18px;
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
  margin-top: 20px;
  font-size: x-large;
  cursor: pointer;
  border: none;
}

.submitButton:hover {
  opacity: 0.9;
}
</style>